export default __webpack_public_path__ + "static/media/02.c1615742.jpg";